import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import api from '../utils/api';
import toast from 'react-hot-toast';
import './Auth.css';

const COUNTRIES = [
  'United States','United Kingdom','Canada','Australia','Germany','France','Netherlands',
  'Switzerland','Singapore','Japan','South Korea','India','Brazil','Mexico','South Africa',
  'Nigeria','Kenya','Ghana','UAE','Saudi Arabia','Turkey','Indonesia','Malaysia','Philippines',
  'Thailand','Vietnam','Pakistan','Bangladesh','Egypt','Colombia','Argentina','Chile','Peru',
  'Poland','Czech Republic','Romania','Ukraine','Russia','China','Hong Kong','Taiwan','Italy',
  'Spain','Portugal','Sweden','Norway','Denmark','Finland','Austria','Belgium','Ireland',
  'New Zealand','Israel','Qatar','Kuwait','Bahrain','Oman','Morocco','Tunisia','Tanzania',
  'Uganda','Ethiopia','Cameroon','Senegal','Ivory Coast','Mozambique','Zimbabwe','Zambia',
  'Dominican Republic','Jamaica','Trinidad and Tobago','Costa Rica','Panama','Ecuador','Paraguay',
  'Uruguay','Bolivia','Venezuela','Guatemala','Honduras','El Salvador','Nicaragua',
  'Croatia','Serbia','Bulgaria','Slovakia','Hungary','Lithuania','Latvia','Estonia',
  'Georgia','Kazakhstan','Uzbekistan','Sri Lanka','Nepal','Myanmar','Cambodia','Laos',
];

export default function CompleteProfile() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({
    firstName: user?.firstName || user?.name?.split(' ')[0] || '',
    lastName:  user?.lastName  || user?.name?.split(' ').slice(1).join(' ') || '',
    country:   user?.country   || '',
    phone:     user?.phone     || '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.firstName.trim() || !form.lastName.trim()) return toast.error('Please enter your full name');
    if (!form.country) return toast.error('Please select your country');
    if (!form.phone.trim()) return toast.error('Please enter your phone number');

    setLoading(true);
    try {
      const { data } = await api.put('/auth/complete-profile', form);
      // Update stored user
      const updatedUser = data.user;
      localStorage.setItem('av_user', JSON.stringify(updatedUser));
      setUser(updatedUser);
      toast.success('Profile completed!');
      navigate('/dashboard');
    } catch (err) {
      toast.error(err.response?.data?.error || 'Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card fade-in-up" style={{ maxWidth: 480 }}>
        <div className="auth-logo">▲ AlphaVault</div>
        <h2>Complete Your Profile</h2>
        <p className="auth-sub">Tell us a bit about yourself to get started</p>

        <form onSubmit={handleSubmit} className="auth-form">
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 14 }}>
            <div className="input-group">
              <label className="input-label">First Name</label>
              <input
                name="firstName" type="text" required
                className="input-field"
                placeholder="John"
                value={form.firstName}
                onChange={handleChange}
              />
            </div>
            <div className="input-group">
              <label className="input-label">Last Name</label>
              <input
                name="lastName" type="text" required
                className="input-field"
                placeholder="Trader"
                value={form.lastName}
                onChange={handleChange}
              />
            </div>
          </div>

          <div className="input-group">
            <label className="input-label">Country</label>
            <select
              name="country" required
              className="input-field"
              value={form.country}
              onChange={handleChange}
            >
              <option value="">Select your country</option>
              {COUNTRIES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>

          <div className="input-group">
            <label className="input-label">Phone Number</label>
            <input
              name="phone" type="tel" required
              className="input-field"
              placeholder="+1 (555) 000-0000"
              value={form.phone}
              onChange={handleChange}
            />
          </div>

          <button type="submit" className="btn btn-primary" style={{ width: '100%' }} disabled={loading}>
            {loading ? 'Saving…' : 'Continue to Dashboard'}
          </button>
        </form>

        <p style={{ fontSize: 12, color: 'var(--text-muted)', textAlign: 'center', marginTop: 16 }}>
          Your information is secure and will only be used for account management.
        </p>
      </div>
    </div>
  );
}
